import { getConfigFor } from "../../../../utils/configService";
import { SPLIT_FEATURES } from "../../../../utils/constants/feature";
import { AnalyticsEvent } from "../../core/AnalyticsEvent";
import { ProductAddedToCartEventSchema } from "../../schemas/product/ProductAddedToCartEventSchema";
import { CommonEventParams } from "../../utils/CommonParams";

export interface ProductAddedToCartEventParams extends CommonEventParams {
    BUSINESS_VERTICAL: string,
    EVENT_CATEGORY: string,
    FULFILMENT_CHANNEL: string,
    CHECKOUT_FLOW: string,
    PRODUCTS : any,
    INDEX: string | null,
    EVENT_TYPE: string,
    EVENT_SUBTYPE: string,
    QUERY_ID: string | null,
}

export class ProductAddedToCartEvent extends AnalyticsEvent {
    constructor(params: ProductAddedToCartEventParams) {
        super(ProductAddedToCartEventSchema, ['segment']);
        this.createEventObject(params);
    }
}

export function trackProductAddedToCartEvent(params: ProductAddedToCartEventParams) {
    const { isEnabled: leapCdpReleaseOne } = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_ONE)
    if (leapCdpReleaseOne) {
        new ProductAddedToCartEvent(params).track();
    }
}